export default __webpack_public_path__ + "static/media/Z2CSilverBadge1stWeek.4cbaebc4.png";